import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-230089bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","margin-top":"5px"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","margin-top":"5px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"100px"} }, "大于:", -1))
const _hoisted_4 = { style: {"display":"flex","align-items":"center","margin-top":"5px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"100px"} }, "小于:", -1))


import { ref, watch } from 'vue'
import { ratingRulesSave, ratingRulesUpdate } from '@/api/gucangSales/ratingRules'
import type { FormInstance } from 'ant-design-vue'
import { RatingRulesSaveParams } from '@/typings/api/gucangSale'
import { message } from 'ant-design-vue'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  pageType: {
    type: String,
    default: 'ratingRules'
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props
const mPageType = ref<string>()

watch(
  props,
  () => {
    mPageType.value = props.pageType
  },
  { immediate: true }
)
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<RatingRulesSaveParams>({})
const emit = __emit
const toggle = (row?: RatingRulesSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { configName, max, min } = editForm.value
    console.log('mPageType.value: ', mPageType.value)
    const p = {
      configName,
      max,
      min,
      logic: `>${editForm.value.min},≤${editForm.value.max}`,
      configType: mPageType.value === 'ratingRules' ? 2 : 1,
      appId: 'cos_fbu'
    }
    try {
      if (editForm.value.id) {
        await ratingRulesUpdate({ ...p, id: editForm.value.id })
      } else {
        await ratingRulesSave(p)
      }
      // toggle()
      loading.value = false
      visible.value = !visible.value
      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "configName",
                label: mPageType.value === 'ratingRules'?'客户评级':'客户档次',
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.configName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.configName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_form_item, {
                  name: "min",
                  label: mPageType.value === 'ratingRules'?'评分区间':'成交额区间',
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createVNode(_component_a_input_number, {
                        value: editForm.value.min,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.min) = $event)),
                        precision: 0,
                        maxlength: 10,
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  name: "max",
                  label: "",
                  rules: [{ required: true, message: '请输入' }],
                  style: {"margin":"5px 0 0 10px"},
                  class: "down-box"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_a_input_number, {
                        value: editForm.value.max,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.max) = $event)),
                        precision: 0,
                        maxlength: 10,
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})